import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

const timeline = () => {
    ScrollTrigger.matchMedia({
        '(min-width: 767px)' : function () {
            gsap.utils.toArray('.timeline-item').forEach((item, i) => {
                const content     = item.querySelector('.timeline-content');
                const image       = item.querySelector('.timeline-image');
                const progressBar = item.querySelector('.timeline-progress');

                gsap.set(item, { opacity : 1 });
                gsap.set(
                    content,
                    {
                        opacity : 1,
                        y       : 0
                    }
                );
                if (image) {
                    gsap.set(
                        image,
                        {
                            opacity : 0,
                            x       : 0,
                            y       : 0
                        }
                    );
                }
                if (progressBar) {
                    gsap.set(progressBar, { height : '0%' });
                }

                let progressFilled = false;

                gsap.timeline({
                    scrollTrigger : {
                        trigger       : item,
                        start         : 'top 65%',
                        end           : 'bottom 50%',
                        toggleActions : 'play none none reverse',
                        markers       : false,
                        onToggle      : (self) => {
                            if (image) {
                                gsap.set(image, { opacity : self.isActive ? 1 : 0 });
                            }

                            if (progressBar && self.isActive && !progressFilled) {
                                gsap.to(progressBar, {
                                    height     : '100%',
                                    duration   : 0.3,
                                    ease       : 'power2.out',
                                    onComplete : () => {
                                        progressFilled = true;
                                    }
                                });
                            }

                            if (progressBar && !self.isActive && self.direction === -1) {
                                gsap.to(progressBar, {
                                    height   : '0%',
                                    duration : 0.3,
                                    ease     : 'power2.out'
                                });
                                progressFilled = false;
                            }
                        }
                    }
                });
            });
        }
    });
};

export default timeline;
